fx.ns("models", class CreationFormat extends fx.Model {

	constructor(data)
	{
		super(data);
    }

    get price()
    {
        return (this.price_base * fx.get("lang").tax).toFixed(2);
    }
});
